import React from 'react'

const HomeScrollSectionFour = (props) => {
    const { setIsAtBottom } = props || {};


    const handleScroll = (event) => {
        const div = event.target;
        const scrollTop = div.scrollTop;
        const divHeight = div.clientHeight;
        const scrollHeight = div.scrollHeight;

        if (scrollTop + divHeight >= scrollHeight) {
            setIsAtBottom(true);
        } else {
            setIsAtBottom(false);
        }
    };


    return (
        <>
            <div style={{
                height: '100vh',
                overflowY: 'scroll',
            }}
                onScroll={handleScroll}
            >
                <div id="section-three" className="background-container d-flex justify-content-center align-items-center">
                    <video className="background-video" autoPlay muted loop>
                        <source src="/video/home1.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>

                    <main className="main-section">
                        <h1 className='text_36_home text-black'> IMMSY's Virtual Avatar  </h1>
                        <div className="avatar-container">
                            <img src="/img/home4.jpg" alt="Black male avatar" className="avatar" />
                        </div>
                    </main>

                    <aside className="progress-indicator">
                        <div className="indicator-item active"></div>
                        <div className="indicator-item"></div>
                        <div className="indicator-item"></div>
                    </aside>
                </div>





                <div class="container mt-5">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="hero-section">
                                <h1 className='text_36_home text-black'>Eira - Your Virtual Assistant</h1>
                                <p className='text_18_about'>Meet Eira, your new partner in personalized wellness.</p>
                            </div>
                            <h2 className='text_36_home text-black'>How Eira Can Assist You Today</h2>
                            <ul class="list-unstyled">
                                <li className='text_18_about'>Get Information on Investment Opportunities: Eira provides information about investment opportunities with IMMSY and guides you through the next steps.</li>
                                <li className='text_18_about'>Learn About Our Future Platform: Get a comprehensive overview of our future platform, launching in early 2025.</li>
                                <li className='text_18_about'>Help You Navigate the Website: Eira can help you find sections like 'About Us,' 'Programs Menu,' and more.</li>
                            </ul>
                        </div>
                        <div class="col-md-6">
                            <div class="card">
                                <img src="/img/home2.jpg" class="card-img-top" alt="Eira Avatar" />
                                <div class="card-body">
                                    <h5 class="card-title">What’s Coming in 2025: New Capabilities with Eira</h5>
                                    <p class="card-text text_18_about">In 2025, Eira will offer personalized wellness programs and real-time support with advanced features for a fully personalized wellness experience.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <h2 className='text_36_home text-black'>Why Choose Eira?</h2>
                        <ul class="list-unstyled">
                            <li className='text_18_about'>Available 24/7:"Eira will always be ready to assist you, anytime, day or night."</li>
                            <li className='text_18_about'>Backed by Expertise and Validated by Professionals:"Eira’s recommendations are based on the latest scientific research and validated by experts in various fields, including nutrition, fitness, mental health, and more. You can trust that the guidance you receive from Eira is both accurate and reliable."</li>
                            <li className='text_18_about'>Powered by Cutting-Edge AI Technology:"As a generative AI, Eira continuously learns and adapts to your needs. We are committed to keeping Eira at the forefront of technology, ensuring that she evolves with the latest advancements in artificial intelligence to provide you with the best possible support."</li>
                            <li className='text_18_about'>Security and Privacy:"Your data is protected with the highest security standards. Eira ensures that all your personal and investment information remains confidential and secure."</li>
                            <li className='text_18_about'>Optimized User Experience:"Eira is designed to make your experience on IMMSY simple, enjoyable, and efficient, quickly responding to all your queries and providing the information you need."</li>
                        </ul>
                    </div>

                    <div class="text-center mt-5">
                        <a href="#explore" class="btn btn-custom">Explore Eira Today!</a>
                    </div>
                </div>

                <div class="container faq-section mt-5">
                    <h2 class="text-center text_36_home text-black">Frequently Asked Questions (FAQ)</h2>
                    <div class="row">
                        <div class="col-md-4">
                            <h5>What can I ask Eira?</h5>
                            <p className='text_18_about'>You can ask Eira about investment opportunities, the future IMMSY platform, and the different sections of the website.</p>
                        </div>
                        <div class="col-md-4">
                            <h5>Can Eira provide personalized wellness recommendations?</h5>
                            <p className='text_18_about'>Not yet. Eira’s capabilities for personalized wellness programs and real-time support will be available starting in 2025.</p>
                        </div>
                        <div class="col-md-4">
                            <h5>How can I access detailed investment information?</h5>
                            <p className='text_18_about'>To access specific investment information, log into your account or join our waitlist.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HomeScrollSectionFour



